<header id="bgr-color" class="header">
  <div class="container main-menu">
    <div id="Menu" class="site-menu">
      <div class="layout-row align-center main-menu-container">
        @if (!isUs) {
          <a href="https://www.gohenry.com/" class="gohenry-logo" aria-label="gohenry logo" (click)="navClick('logo','header')">
            <img class="dark-logo long" [src]="cdnPath + '/develop/gohenry-logo.svg'" alt="gohenry logo" width="100px" height="35px">
            <img class="light-logo long" [src]="cdnPath + '/develop/gohenry-logo-white.svg'" alt="gohenry logo" width="100px" height="35px">
            <img class="short" [src]="cdnPath + '/develop/go-logo-red.svg'" alt="gohenry logo" width="35px" height="35px">
          </a>
        } @else {
          <a [href]="website" class="gohenry-logo" aria-label="gohenry logo" (click)="navClick('logo','header')">
            <gh-logo></gh-logo>
          </a>
        }

        <div class="tabs layout-row flex-all" [ngClass]="{'center': isUs === false }">
          @for (item of mainMenu; track item) {
            @if (item.label === 'Blog') {
              <div class="tab bold">
                <a [href]="root" (click)="navClick('Blog','header')">{{item.label}}</a>
              </div>
            } @else {
              @if (item.label === 'Support') {
                <div class="tab">
                  <a [href]="support" (click)="navClick(item.label,'header')">{{item.label}}</a>
                </div>
              } @else {
                @if (item.submenu) {
                  <div class="tab has-dropdown">
                    <span>{{item.label}}
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11.486 6.53625L6.94971 11.8995L2.41345 6.53625" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        </path>
                      </svg>
                    </span>
                    <div class="dropdown-menu">
                      @for (subItem of item.submenu; track subItem) {
                        <a [href]="subItem.label === 'Support' ? support : envUrl+subItem.page" [class.bold]="subItem.label === 'Blog'"
                        (click)="navClick(subItem.label,'header')">{{subItem.label}}</a>
                      }
                    </div>
                  </div>
                } @else {
                  <div class="tab">
                    <a [href]="envUrl+item.page" (click)="navClick(item.label,'header')">{{item.label}}</a>
                  </div>
                }
              }
            }
          }
        </div>

        @if (!isUs) {
          <div class="flex flex-none">
            <a [href]="signup" (click)="ctaClick('Start free trial','header')" class="btn btn-primary">Start free trial</a>
          </div>
          <div class="flex flex-none">
            <a [href]="webapp" (click)="navClick('Log in','header')" class="btn btn-white">Log in</a>
          </div>
          <button class="hamburger flex flex-none" [class.opened]="isDrawerOpened" (click)="toggleDrawer()" aria-label="Menu">
            <span></span>
            <span></span>
            <span></span>
          </button>
        } @else {
          <div class="flex flex-none">
            <a id='menu-signup' [href]="signup" (click)="ctaClick('Start free trial','header')" class="btn btn-primary">Start free trial</a>
          </div>
          <div class="flex flex-none">
            <a id='menu-login' [href]="webapp" (click)="navClick('Log in','header')" class="btn btn-dark">Log in</a>
          </div>
          <div class="flex flex-none">
            <a id='menu-switch' [href]="webapp" (click)="toggleClick($event.target)" (window:scroll)="swapButton()" class="btn btn-dark" slot="Log in"></a>
          </div>
          <button class="hamburger flex flex-none" [class.opened]="isDrawerOpened" (click)="toggleDrawer()" aria-label="Menu">
            <span></span>
            <span></span>
            <span></span>
          </button>
        }


      </div>
    </div>
    <gh-category-menu></gh-category-menu>
  </div>
</header>


<router-outlet></router-outlet>

<gh-carousel class="layout-row bgr-pink" [articles]="popularArticles"></gh-carousel>

@if (!isUs) {
  <gh-trial-component></gh-trial-component>
} @else {
  <gh-trial-us-component></gh-trial-us-component>
}


@if (!isUs) {
  <gh-footer></gh-footer>
} @else {
  <gh-footer-us></gh-footer-us>
}

<div class="overlay"></div>

<gh-side-menu class="hide-desktop" [menu]="mainMenu" (whenMenuClose)="toggleDrawer()"></gh-side-menu>
